/**
 * Keeps the theme cart bubble in sync when a third-party app (e.g. UpCart)
 * mutates the cart via Shopify's AJAX Cart API without firing the theme's
 * internal `cart:update` event.
 *
 * Works by wrapping the global fetch so any successful POST/PATCH to a cart
 * mutation endpoint triggers a `/cart.js` count refresh and then re-dispatches
 * the event that CartIcon listens to.
 */
(function () {
  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const CART_UPDATE_EVENT = 'cart:update';

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
      const method = (args[1]?.method ?? 'GET').toUpperCase();
      const isMutation = ['POST', 'PATCH', 'PUT'].includes(method);

      if (isMutation && CART_MUTATION_RE.test(url) && response.ok) {
        // Clone so the original response body is still readable by the caller
        syncCartCount();
      }
    } catch (_) {
      // Never let our wrapper break the caller
    }

    return response;
  };

  function syncCartCount() {
    originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const itemCount = cart.item_count ?? 0;
        document.dispatchEvent(
          new CustomEvent(CART_UPDATE_EVENT, {
            bubbles: true,
            detail: { data: { itemCount, source: 'third-party-cart-sync' } },
          })
        );
      })
      .catch(() => {});
  }
})();
